import { Box, Typography } from '@material-ui/core';
import React from 'react';
import logo from './logo.png';

function Logo() {
  return (
    <Box display='flex' flexDirection='column'>
      <img src={logo} alt="Panoscape Logo" />
      <Typography variant='h5'>Management Console</Typography>
    </Box>
  );
}

export default Logo;
